import { addMessages, init } from "svelte-i18n";
import { LangEnums, storageModel } from "../libs/storage-manager";
import enUS from "./assets/langs/en-us.json";
import koKR from "./assets/langs/ko-kr.json";
import zhCN from "./assets/langs/zh-cn.json";
import zhHk from "./assets/langs/zh-hk.json";
import { locale } from "svelte-i18n";

addMessages("en-us", enUS);
addMessages("ko-kr", koKR);
addMessages("zh-cn", zhCN);
addMessages("zh-hk", zhHk);

let lang = "";
if (storageModel.language) {
  if (storageModel.language === LangEnums.zhCN) {
    lang = "zh-cn";
  } else if (storageModel.language === LangEnums.zhHK) {
    lang = "zh-hk";
  } else if (storageModel.language === LangEnums.koKR) {
    lang = "ko-kr";
  } else {
    lang = "en-us";
  }
}

init({
  fallbackLocale: "en-us",
  initialLocale: lang,
});
locale.set(lang);
